const BONUS_ITEMS_IDS = {
  10408802156808: {
    variants: { default: 51972588699912 },
    compare_at_price: 3990,
  },
  10408427487496: { 
    variants: { default: 51970075984136 },
    compare_at_price: 2999,
  },
  10408432992520: {
    variants: {
      default: 51970090434824,
      white: 51970090467592,
      black: 51970090434824,
    },
    compare_at_price: 999,
  },
  10408781447432: { 
    variants: { default: 51972484301064 },
    compare_at_price: 1999,
  },
  10408796782856: { 
    variants: { default: 51972570611976 },
    compare_at_price: 3998,
  },
  10456270831880: { 
    variants: { default: 52148774174984 },
    compare_at_price: 5499,
  },
  10588262629640: {
    variants: { default: 52756223918344 },
    compare_at_price: 2499,
  },
  10588263547144: {
    variants: { default: 52756225130760 },
    compare_at_price: 1499,
  },
  10588783411464: {
    variants: { default: 52759166484744 },
    compare_at_price: 2499,
  }
};

/**
 * Convert EUR amount to active currency
 * @param {number} eurAmount - Amount in EUR cents
 * @returns {number} - Amount in active currency cents
 */
function convertEurToActiveCurrency(eurAmount) {
  if (typeof window === "undefined") return eurAmount;
  
  const activeCurrency = window.Shopify?.currency?.active || "EUR";
  if (activeCurrency === "EUR") {
    return eurAmount;
  }

  const currencyRate = window.Shopify?.currency?.rate || 1;
  return Math.round(eurAmount * currencyRate);
}

/**
 * Get converted compare at price for bonus item
 * @param {number} productId - Product ID
 * @returns {number|null} - Compare at price in active currency cents
 */
function getBonusItemCompareAtPrice(productId) {
  const item = BONUS_ITEMS_IDS[Number(productId)];
  if (!item || !item.compare_at_price) {
    return null;
  }
  
  return convertEurToActiveCurrency(item.compare_at_price);
}


/**
 * Get bonus items for a specific bundle
 *
 * @param {string} bundleProductID - The main bundle product ID
 * @param {string} variant - The desired bonus variant (default, white, black)
 *
 * @return {Array} Array of bonus item variant IDs, or empty array if no bonus items
 */
function getBonusItemsForBundle(bundleItems, variant = "default") {
  const bonusItemsReturn = [];
  console.log("payload:", bundleItems);
  
  // Check if bundleItems is null or not an array
  if (!bundleItems || !Array.isArray(bundleItems)) {
    console.warn("getBonusItemsForBundle: bundleItems is null or not an array");
    return bonusItemsReturn;
  }
  

  bundleItems.map((itemId) => {
    const item = BONUS_ITEMS_IDS[Number(itemId)];
    console.log("item", item);
    if (!item) return null;
    const selectedVariant = item.variants[variant] || item.variants.default;
    console.log("selectedVariant", selectedVariant);
    bonusItemsReturn.push(selectedVariant);
  });

  return bonusItemsReturn.filter(Boolean); // Remove any null values
}

// Make functions available globally for debugging
if (typeof window !== "undefined") {
  window.getBonusItemsForBundle = getBonusItemsForBundle;
  window.getBonusItemCompareAtPrice = getBonusItemCompareAtPrice;
  window.convertEurToActiveCurrency = convertEurToActiveCurrency;
}

// Export for use in other files
if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    getBonusItemsForBundle,
    getBonusItemCompareAtPrice,
    convertEurToActiveCurrency,
  };
}
